/**
*
* DynamicSelectBox
*
*/

import DynamicSelectBox from './DynamicSelectBox.jsx'
import './DynamicSelectBox.less'

export default DynamicSelectBox